import { useEffect } from "react";
import CallStore from "../../stores/CallStore";
import { observer } from "mobx-react";
import { useNavigate } from "react-router";

const EndCallByTechForCustomer = ({ client }) => {
  const navigate = useNavigate();
  const { isOpenEndCallByTechForCustomer } = CallStore;


  useEffect(() => {
    if (!isOpenEndCallByTechForCustomer) return;

    localStorage.removeItem('callToken');

    if (client) {
      client.leave();
    }

    navigate('/customer/review');

  }, [isOpenEndCallByTechForCustomer]);

  return null;
};

export default observer(EndCallByTechForCustomer);